function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i] != null ? arguments[i] : {};var ownKeys = Object.keys(source);if (typeof Object.getOwnPropertySymbols === 'function') {ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {return Object.getOwnPropertyDescriptor(source, sym).enumerable;}));}ownKeys.forEach(function (key) {_defineProperty(target, key, source[key]);});}return target;}function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}var MODALS = [];
var modalsCount = 0;

export var MODAL_TYPES = {
  BASE: 'base',
  ALERT: 'alert',
  CONFIRM: 'confirm',
  PROMPT: 'prompt',
  MAGNIFIC: 'magnific',
  CUSTOM: 'custom' };var



Modal = /*#__PURE__*/function () {_createClass(Modal, [{ key: "defaults", get: function get()

    {return {
        id: 0,
        options: {
          $scope: null, // angular $scope
          title: '',
          template: '',
          confirmButtonText: 'Ok',
          cancelButtonText: 'Cancel',
          inputPlaceholder: 'Enter response...',
          element: null,
          onInit: function onInit() {} },

        result: null, // Promise

        _resolve: null,
        _reject: null,
        _closed: false };
    } }]);

  function Modal() {var _this = this;var modalOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var Promise = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.Promise;_classCallCheck(this, Modal);
    angular.element('body').addClass('is-show-modal');
    var getScrollDiv = angular.element('<div style="width:50px;height:50px;overflow:hidden;position:absolute;left:-9999px;"><div style="height:100px;"></div>');
    angular.element('body').append(getScrollDiv);
    var widthOuter = angular.element('div', getScrollDiv).innerWidth();
    getScrollDiv.css('overflow-y', 'scroll');
    var widthInner = angular.element('div', getScrollDiv).innerWidth();
    $(getScrollDiv).remove();
    $('body').css({ 'padding-right': widthOuter - widthInner, 'overflow': 'hidden' });
    this.Promise = Promise;
    MODALS.push(this);
    Object.assign(this, _objectSpread({},
    this.defaults, {
      options: Modal.getOptionsForType(modalOptions.type, _objectSpread({},
      this.defaults.options, modalOptions)),

      id: ++modalsCount }));

    this.result = new this.Promise(function (rs, rj) {
      _this._resolve = rs;_this._reject = rj;
    });
  }_createClass(Modal, [{ key: "close", value: function close()

    {var ok = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      $('body').css({ 'padding-right': '', 'overflow': '' });
      this._closed = true;
      this["_".concat(ok ? 'resolve' : 'reject')](message);
      var index = MODALS.indexOf(this);
      index !== -1 && MODALS.splice(index, 1);

      return this;
    } }, { key: "accept", value: function accept()

    {var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.close(true, message);
    } }, { key: "decline", value: function decline()

    {var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.close(false, message);
    } }, { key: "repeat", value: function repeat()

    {
      this.close();
      var newModal = new Modal(this.options, this.Promise);
      this.result = newModal.result;
      this.close = newModal.close.bind(newModal);
      return newModal;
    } }], [{ key: "getOptionsForType", value: function getOptionsForType(

    modalType) {var originalOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var optsForType = function () {
        switch (modalType) {

          case MODAL_TYPES.ALERT:return {
              template: "\n            <ui-modal-alert\n              modal-title=\"".concat(

              originalOptions.title || '', "\"\n              confirm-button-text=\"").concat(
              originalOptions.confirmButtonText, "\"\n              on-close=\"$modal.decline();\"\n              on-confirm=\"$modal.accept();\"\n              hide-close=\"").concat(


              originalOptions.hideClose, "\"\n              class=\"show-ui-modal\">\n              <ui-modal-content>").concat(

              originalOptions.template || '', "</ui-modal-content>\n            </ui-modal-alert>\n          ") };




          case MODAL_TYPES.CONFIRM:return {
              template: "\n            <ui-modal-confirm\n              modal-title=\"".concat(

              originalOptions.title || '', "\"\n              confirm-button-text=\"").concat(
              originalOptions.confirmButtonText, "\"\n              cancel-button-text=\"").concat(
              originalOptions.cancelButtonText, "\"\n              on-close=\"$modal.decline();\"\n              on-confirm=\"$modal.accept();\"\n              class=\"show-ui-modal\">\n              <ui-modal-content>").concat(



              originalOptions.template || '', "</ui-modal-content>\n            </ui-modal-confirm>\n          ") };




          case MODAL_TYPES.PROMPT:return {
              template: "\n            <ui-modal-prompt\n              modal-title=\"".concat(

              originalOptions.title || '', "\"\n              confirm-button-text=\"").concat(
              originalOptions.confirmButtonText, "\"\n              cancel-button-text=\"").concat(
              originalOptions.cancelButtonText, "\"\n              input-placeholder=\"").concat(
              originalOptions.inputPlaceholder, "\"\n              on-close=\"$modal.decline();\"\n              on-confirm=\"$modal.accept(result);\"\n              class=\"show-ui-modal\">\n              <ui-modal-content>").concat(



              originalOptions.template || '', "</ui-modal-content>\n            </ui-modal-prompt>\n          ") };




          case MODAL_TYPES.MAGNIFIC:return {
              template: "\n            <ui-modal-magnific\n              on-init=\"".concat(

              originalOptions.onInit(event) || '', "\"\n              on-close=\"").concat(
              originalOptions.onClose(event) || '', "\"\n              class=\"show-ui-modal\">\n              <ui-modal-content>").concat(

              originalOptions.template || '', "</ui-modal-content>\n            </ui-modal-magnific>\n          ") };




          case MODAL_TYPES.CUSTOM:return {
              template: "\n            <ui-modal-custom\n              on-init=\"".concat(

              originalOptions.onInit(event) || '', "\"\n              on-close=\"$modal.decline();$ctrl.$scope.$modal = false;\"\n              class=\"show-ui-modal\">\n              <ui-modal-content>").concat(


              originalOptions.template || '', "</ui-modal-content>\n            </ui-modal-custom>\n          ") };



          default:return {};}

      }();
      return _objectSpread({}, originalOptions, optsForType);
    } }]);return Modal;}();




export var ModalsService = /*#__PURE__*/function () {ModalsService.$inject = ["$q"];

  function ModalsService($q) {
    "ngInject";_classCallCheck(this, ModalsService);
    this.$q = $q;
  }_createClass(ModalsService, [{ key: "getModals", value: function getModals()



    {return MODALS.concat();} }, { key: "show", value: function show()

    {var modalOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new Modal(modalOptions, this.$q);
    } }, { key: "alert", value: function alert()

    {var modalOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.show(_objectSpread({}, modalOptions, { type: MODAL_TYPES.ALERT }));
    } }, { key: "confirm", value: function confirm()

    {var modalOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.show(_objectSpread({}, modalOptions, { type: MODAL_TYPES.CONFIRM }));
    } }, { key: "prompt", value: function prompt()

    {var modalOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.show(_objectSpread({}, modalOptions, { type: MODAL_TYPES.PROMPT }));
    } }, { key: "magnific", value: function magnific()

    {var modalOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.show(_objectSpread({}, modalOptions, { type: MODAL_TYPES.MAGNIFIC }));
    } }, { key: "custom", value: function custom()

    {var modalOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.show(_objectSpread({}, modalOptions, { type: MODAL_TYPES.CUSTOM }));
    } }, { key: "closeLast", value: function closeLast()

    {
      if (!MODALS.length) return false;
      return MODALS[MODALS.length - 1].close();
    } }, { key: "closeAll", value: function closeAll()

    {var reason = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      return MODALS.splice(0).map(function (modal) {return modal.decline(reason);});
    } }, { key: "length", get: function get() {return MODALS.length;} }]);return ModalsService;}();